// import React from "react";
// import {Navigate} from 'react-router-dom'

// export function PrivateRoute({ children }) {
//     const auth = localStorage.getItem("authToken");
//     return auth ? (
//       children
//     ) : (
//       <Navigate to={"/"} />
//     );
//   }

//   export function PublicRoute({ children }) {
//     const auth = localStorage.getItem("authToken");

//     return auth ? <Navigate to="/dashboard" /> : children;
//   }

import React from "react";
import { Navigate } from "react-router-dom";
import { useContext } from "react";
import { userContext } from "../../context/user";

export function PrivateRoute({ children }) {
  const { userDetails } = useContext(userContext);
  return userDetails ? children : <Navigate to={"/"} />;
  // const auth = localStorage.getItem("authToken");
  // return auth ? children : <Navigate to={"/"} />;
}

export function PublicRoute({ children }) {
  // const auth = localStorage.getItem("authToken");
  // return auth ? <Navigate to="/dashboard" /> : children;
  const { userDetails } = useContext(userContext);
  return userDetails ? <Navigate to="/dashboard" /> : children;
}
